export default __webpack_public_path__ + "static/trading-5247fb8b68cc5409b874e396fe043931.png";